import { render, staticRenderFns } from "./fontTypeSelect.vue?vue&type=template&id=51065ade"
import script from "./fontTypeSelect.vue?vue&type=script&lang=js"
export * from "./fontTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports